import {
  getApiInstance,
  getApiInstanceForHulAuth,
} from "services/ApiInstance";
import {
  CREATE_HUL_PARTNER_USER_API,
  AUTH_TOKEN_URL,
  DECRYPT_HUL_PARTNER_USER_API,
} from "services/constant";
import { storeUserInfo } from "utils/authHelpers";

/**
 * Creates a partner user (e.g., for HUL).
 * @param {object} data The request payload.
 * @param {string} data.partnerType The type of the partner (e.g., "HUL").
 * @param {string} data.encData The encrypted data string.
 * @returns {Promise<object>} The response from the API.
 */
export const createHulPartnerUser = async (data) => {
  const instance = getApiInstance();
  try {
    const response = await instance.post(CREATE_HUL_PARTNER_USER_API, data);
    return response.data || null;
  } catch (error) {
    console.error("Error creating partner user:", error.response);
    return error.response;
  }
};

/**
 * Decrypts HUL partner user data.
 * @param {object} data The request payload.
 * @param {string} data.partnerType The type of the partner (e.g., "HUL").
 * @param {string} data.encData The encrypted data string.
 * @returns {Promise<object>} The response from the API.
 */
export const decryptHulPartnerUser = async (data) => {
  const instance = getApiInstance();
  try {
    const response = await instance.post(DECRYPT_HUL_PARTNER_USER_API, data);
    return response.data || null;
  } catch (error) {
    console.error("Error decrypting partner user:", error.response);
    throw error.response;
  }
};

/**
 * Gets an authentication token for a HUL partner user.
 * @param {string} encryptedPayload The encrypted payload string.
 * @returns {Promise<object>} The response from the API.
 */
export const getHulAuthToken = async (encryptedPayload) => {
  const instance = getApiInstanceForHulAuth();

  const params = new URLSearchParams();
  params.append("grant_type", "encrypted_string");
  params.append("encrypted_payload", encryptedPayload);
  params.append("client_id", "encrypted_string_client");

  try {
      const response = await instance.post(AUTH_TOKEN_URL, params);
      if (response.status === 200) {
        // Storing token and profileId in session storage for subsequent API calls
        sessionStorage.setItem("token", response.data.access_token);
        sessionStorage.setItem("profileId", response.data.randomNo);
        console.log("HUL___getHulAuthToken", response.data);
    }
    return response.data;
  } catch (error) {
    console.error("Error getting HUL auth token:", error.response);
    return error.response;
  }
};
